import ProcessTableContainer from './ProcessTableContainer';

export default ProcessTableContainer;